import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { rgba } from 'color-helpers';
import React from 'react';

const DATA_ENTRY_ROW_PADDING_HEIGHT = 8;

export const AddOnColumn = React.memo(styled.div`
  padding: ${DATA_ENTRY_ROW_PADDING_HEIGHT}px 8px;
`);

export const IconColumn = React.memo(styled.div<{ styleType?: string }>`
  ${({ styleType }) =>
    styleType === 'warning' &&
    `
      background: ${rgba(colors.copper, 0.1)};
      box-shadow: inset 1px 0 0 ${colors.copper};
    `};
  padding: ${DATA_ENTRY_ROW_PADDING_HEIGHT}px 0;
  text-align: center;
  svg {
    display: block;
  }
`);

export const AmountColumn = React.memo(styled.div<{ isDebit?: boolean }>`
  color: ${({ isDebit }) => (isDebit ? '#217950' : '#ae280e')};
  padding: ${DATA_ENTRY_ROW_PADDING_HEIGHT}px 8px;
  text-align: right;
`);

export const DateColumn = React.memo(styled.div`
  color: ${colors.cloud};
  padding: 8px 8px;
`);

export const TextCell = React.memo(styled.div`
  padding: 0 8px;
`);

export const Columns1099 = React.memo(styled.div`
  display: flex;
  flex-basis: 80px;
  min-width: 80px;
  padding: ${DATA_ENTRY_ROW_PADDING_HEIGHT}px 8px;
`);
